<template>
  <div>

    <br>

    <v-row justify="center">
      <v-dialog v-model="dialogIndividual" width="430px">
        <v-card>
          <v-card-text style="text-align: justify;">
            <div>
              <v-btn icon @click="dialogIndividual = false" style="float: right;">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <br>
              <br>
              <div style="background: #002C77; border-radius: 9px; text-align: center;">
                <div style="padding: 2%;">
                  <label style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 13px; line-height: 18px; letter-spacing: 0.02em;
                      color: white; flex: none; order: 1; flex-grow: 0;">Estas son las coberturas y protecciones
                    del </label>
                  <label style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 13px; line-height: 18px; letter-spacing: 0.02em;
                      color: white; flex: none; order: 1; flex-grow: 0;"><label
                      style="font-family: Helvetica; font-style: normal; font-weight: 700; 
                      font-size: 13px; line-height: 18px; letter-spacing: 0.02em; color: white; flex: none; order: 1; flex-grow: 0; text-transform: uppercase;">
                      </label> <br> Seguro Oncológico Clínica IRAM.
                  </label>
                </div>

              </div>


              <br>
              <div style="padding-left: 5%; ">
                <label class="encabezado"> ⬤ <b>   Cobertura completa en tratamiento oncológico individual </b> </label>
              </div>

              <br>

              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 10px">
                <label class="texto">La cobertura tiene como finalidad complementar el régimen previsional de salud del asegurado, sea Fonasa (B, C, D) o Isapre, proporcionando acceso a tratamientos, hospitalización para patologías oncológicas y seguimiento oncológico, con cobertura vitalicia mientras el asegurado mantenga su pago y contrato vigente.</label>
              </div>
              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 20px">
                <label class="texto">La cobertura es de carácter asistencial y contempla una indemnización de UF 50 en caso de diagnóstico de cáncer. El derecho a la indemnización no procederá si el diagnóstico de cáncer es consecuencia de otro anterior cubierto por la póliza. Todos los tratamientos y prestaciones deben ser indicados sólo por Clínica IRAM, realizados en su propia Clínica o en centros derivados por la misma.</label>
              </div>
              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 5px">
                <label class="texto">La cobertura oncológica se inicia una vez que el paciente presenta el resultado de una biopsia (informe histopatológico), que confirma que tiene cáncer. La realización de esta biopsia es de cargo del asegurado.</label>
              </div>

              <br>
              <div style="padding-left: 9%; ">
                <label class="encabezado"> ⬤ <b>  Beneficios adicionales </b> </label>
              </div>


              <br>
              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 20px">
                <label class="texto">La cobertura y beneficios adicionales es complementaria al sistema previsional de cada persona (Fonasa o Isapre), es decir cubrirá los valores copago no cubiertos por éstas.</label>
              </div>

              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 20px">
                <label class="texto"> <b>Para diagnóstico precoz del cáncer de mama: </b> <br>
                  • 1 mamografía anual sin costo desde los 35 años.<br>
                  • Este examen se realiza: en Santiago y en regiones en los Centros Médicos convenidos por IRAM.
                </label>
              </div>

              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 20px">
                <label class="texto"> <b>Para diagnóstico precoz del cáncer de próstata:</b><br>
                  • 1 examen anual de antígeno prostático específico (PSA) sin costo desde los 45 años.<br>
                  • Este examen se realiza: en Santiago y en regiones en los Centros Médicos convenidos por IRAM.
                </label>
              </div>

              <br>

            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn style="box-sizing: border-box; padding: 12px 24px; gap: 10px; background: #4F74E3; border: 2px solid #4F74E3;
                    border-radius: 8px; margin-top: -6%; font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 14px; line-height: 17px;
                    letter-spacing: 0.02em; color: white; flex: none; order: 0; flex-grow: 0; margin:auto;"
              elevation="0" text @click="dialogIndividual = false">
              Aceptar
            </v-btn>
            <br>
            <br>
            <br>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>

      <div class="ContainerPlans" v-if="loadingPlans == false">

        <div >

          <div class="planFamiliarConveniente">Plan Seguro Oncológico</div>

        </div>

        <div class="plan-valid">

            <div class="planFamiliarConvenienteValid">Válido para Fonasa e Isapre</div>

        </div>

        <div >

            <p class="planFamiliarName" style="margin-top: 3%;">Precio mensual</p>

            <div style="display: flex; justify-content: center; height: 33px; margin-top: 2%;" >
              <p class="planFamiliarPrecio">{{ formatPrice(planData[0].values[0].priceCLP) }} *</p>
              <div>
                <p></p>   
                <p class="planFamiliarSubPrecio">   UF {{ (planData[0].values[0].price).toFixed(2) }}</p>   
              </div>
            
            </div>
          

            <label class="planFamiliarSubDetalle">* Valor de la UF al día de hoy, {{ currentDate }}.</label>
            
            <div class="planShield"  style="margin-top: 3%;">
              <img :src=iconShield alt="Protecciones" class="imgShield" >
              <p class="planShieldDetalle">El Plan otorga atención y cobertura completa de los gastos que implica el tratamiento, control y seguimiento del cáncer.</p>
            </div>
          
            <div class="planSubShield">
              <img :src=iconSand alt="Protecciones" class="imgSand" >
              <p class="planSubShieldDetalle">Este seguro tiene un tiempo de espera de activación de 30 días contínuos.</p>
            </div>

            <p></p>

     
          </div>

          <hr class="hrLinePlan">

          <br>

          <div class="plan-skin" style="border-radius: 0px 0px 0px 0px !important;">

            <p class="planIndividualBeneficios">Cubre tratamiento para todos los tipos de cáncer, incluso cáncer in situ y el tratamiento del cáncer a la piel.
            </p>
            <p></p>
            <p class="planIndividualBeneficios">La atención oncológica es solo en  la ciudad de Santiago de Chile. Traslados y estadías no estarán cubiertos por el seguro.
            </p>
            <p></p>
            <p class="planIndividualBeneficios">Todo el tratamiento integral del paciente lo realiza Clínica IRAM, derivando a los profesionales y/o centros hospitalarios en convenio en la ciudad de Santiago.
            </p>
            <p></p>
            <p class="planIndividualBeneficios">Cubre la realización de exámenes y procedimientos necesarios para identificar el tipo y estado de extensión del cáncer.
            </p>
            <p></p>
            <p class="planIndividualBeneficios">Ejecución de tratamiento comprobado y multidisciplinario de la enfermedad (Cirugía, Quimioterapia y Radioterapia).
            </p>
            <p></p>
            <p class="planIndividualBeneficios">Hospitalización como un todo. Incluye los días cama, derechos de pabellón, UTI intermedio, procedimientos diagnósticos intrahospitalarios.
            </p>
            <p></p>
            <p class="planIndividualBeneficios">Incluye todos los honorarios médicos: quirúrgicos, de radioterapeutas, de quimioterapeutas y honorarios del equipo paramédico quirúrgico.
            </p>
            <p></p>
            <p class="planIndividualBeneficios">Cobertura vitalicia mientras se mantenga el pago y la póliza vigente.
            </p>
            <p></p>
            <p class="planIndividualBeneficios">Ante diagnóstico de cáncer positivo, recibirás una indemnización de UF 50 para libre disposición.
            </p>
            <p></p>
            <p class="planSubTopes"  style="text-align: center !important;">Únicos topes:
            </p>
            <p></p>
            <p class="planIndividualBeneficios">Drogas antineoplásicas: tope UF 100 por cada tratamiento de quimioterapia.
            </p>
            <p></p>
            <p class="planIndividualBeneficios">Farmacia intrahospitalaria: medicamentos, insumos, materiales clínicos y banco de sangre: UF 4 tope por hospitalización.
            </p>

            <p style="margin-top: 13%;"></p>
          <br>

        </div>

        <div class="plan-skin">

          <div class="text-center">
            <p class="planSubTopes" style="text-align: center !important;">Estamos para aclarar tus dudas</p>

          </div>

          <div>
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel style="margin-bottom: 2%; margin-top: 2%;">
                <v-expansion-panel-header>
                  ¿Este seguro tiene beneficios adicionales?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-expan">
                  Sí, este seguro cuenta con los siguientes beneficios:
                  <ul>
                    <li>1 mamografía anual sin costo desde los 35 años para mujeres.</li>
                    <li>1 examen anual de antígeno prostático específico (PSA) sin costo desde los 45 años para hombres.</li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            
              <v-expansion-panel style="margin-bottom: 2%">
                <v-expansion-panel-header>
                  ¿Cómo uso mi seguro?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-expan">
                  Si te diagnostican cáncer, notifícalo a través de nuestro sitio web o por correo a 
                  <a href="mailto:siniestros@sbins.cl">siniestros@sbins.cl</a> o al <strong>800 200 802</strong> 
                  lo antes posible (máximo 30 días, salvo fuerza mayor).<br /><br />
                  <strong>Documento requerido para la denuncia del siniestro:</strong>  
                  Informe de biopsia con diagnóstico de cáncer confirmado.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel style="margin-bottom: 2%">
                <v-expansion-panel-header>
                  ¿Qué es la Clínica IRAM?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-expan">
                  Clínica IRAM cuenta con más de 45 años de trayectoria dedicados al tratamiento del cáncer. 
                  Posee tecnología de primer nivel y un equipo médico multidisciplinario altamente calificado.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel style="margin-bottom: 2%">
                <v-expansion-panel-header>
                  ¿Puedo contratarlo si tengo Fonasa?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-expan">
                  Este seguro puede ser contratado con los tramos B, C y D de Fonasa. No incluye Fonasa “A” ni PRAIS.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel style="margin-bottom: 2%">
                <v-expansion-panel-header>
                  Soy parte de las fuerzas de orden y seguridad de Chile ¿Puedo contratarlo?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-expan">
                  Sí, este seguro cubre FFAA, Carabineros, PDI.
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </div>

          <div class="plan-info" >
            <button style="display: flex; margin: auto; align-items: center; text-align: center;">
              <b>
                <u class="planIndividualVerDetalle"  elevation="0" @click="InfoIndividual()">
                  VER DETALLE
                </u>
              </b>
            </button>
          </div>

          <br>

          <v-btn class="button-desing"  style="background-color: #FFFFFF; display: flex; margin: auto; align-items: center;"  @click="next(planData[0], 0)">
            <label style="color: #FFFFFF;">Continuar</label>
          </v-btn> 

          <br>
          <br>


        </div>

      </div>
  </div>
</template>

<script>
import ShieldService from "@/services/shield.service.js";
import LibreEleccion from "../assets/images/libreeleccion.png";
import iconShield from "../assets/images/shield-check.svg";
import iconSand from "../assets/images/time-sand.svg";
import CryptoJS from 'crypto-js';
import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "Plan",
  props: ["planData", "userData", "loadingPlans", "planDataAux", "servicesData", "plansOutDesc"],
  data() {
    return {
      secretKey: process.env.VUE_APP_CRYPT,
      newElegirPlanIndividual: 'elegirPlan',
      newElegirPlanFamiliar: 'elegirPlan',
      stepperColor: '#4F74E3',
      verMasIndividual: false,
      verMasFamiliar: false,
      formatter: new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
      }),
      iconSand,
      currentDate: "",
      iconShield,
      LibreEleccion,
      formatterUF: new Intl.NumberFormat("es-CL"),
      e1: 3,
      info: [['Isapre Individual', 'Isapre Familiar', 'Fonasa Individual', 'Fonasa Familiar'], ['100%', '100%', '100%', '100%'], ['50', '50', '50', '50'], ['30.000', '30.000', '30.000', '30.000'], ['5.000', '5.000', '5.000', '5.000'], ['50', '50', '50', '50'], ['10', '10', '10', '10'], ['0', '30.000', '0', '30.000'], ['0', '50', '0', '50']],
      indexInfo: '0',
      dialogIndividual: false,
      dialogFamiliar: false,
      document: null,
      activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
      couponRules: [
        (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres"
      ],
    }
  },
  async mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    const today = new Date();
    this.currentDate = today.toLocaleDateString("es-CL"); 
  },
  methods: {
    ufFormat(price) {
      return this.formatterUF.format(price);
    },
    VerMasIndividual() {
      if (this.verMasIndividual == false) {
        this.verMasIndividual = true
        this.newElegirPlanIndividual = 'elegirPlan2'
      } else {
        this.verMasIndividual = false
        this.newElegirPlanIndividual = 'elegirPlan'
      }
    },
    VerMasFamiliar() {
      if (this.verMasFamiliar == false) {
        this.verMasFamiliar = true
        this.newElegirPlanFamiliar = 'elegirPlan2'
      } else {
        this.verMasFamiliar = false
        this.newElegirPlanFamiliar = 'elegirPlan'
      }
    },
    formatPrice(number) {
      return this.formatter.format(number);
    },
    InfoFamiliar() {
      if (this.planData[1].name == 'Plan Familiar ISAPRE') {
        this.indexInfo = 1
        this.document = '/documents/ISAPRE_v2.pdf'
      }
      else if (this.planData[1].name == 'Plan Familiar FONASA') {
        this.indexInfo = 3
        this.document = '/documents/FONASA_v2.pdf'
      }
      this.dialogFamiliar = true
    },
    InfoIndividual() {
      if (this.planData[0].name == 'Plan Individual ISAPRE') {
        this.indexInfo = 0
        this.document = '/documents/ISAPRE_v2.pdf'
      }
      else if (this.planData[0].name == 'Plan Individual FONASA') {
        this.indexInfo = 2
        this.document = '/documents/FONASA_v2.pdf'
      }
      this.dialogIndividual = true
    },
    async next(plan) {

      // reCaptcha v3 token
      await this.$recaptchaLoaded();
      const tokenStep = await this.$recaptcha('captchaToken');

      // console.log(plan);
      // console.log(index);

      this.planDataAux.plan = plan;

      // console.log(this.planDataAux.plan);
      // console.log(this.plansOutDesc[index]);
      // this.planDataAux.planOutDesc = this.plansOutDesc[index].values[0].priceCLP;
      // console.log(this.planDataAux.planOutDesc);

      
      const planDataLocal = JSON.stringify(this.planDataAux);
      // console.log(planDataLocal);
      const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
      sessionStorage.setItem('planData', encryptedPlanDataLocal);

      var namePlanAux = plan.name.split(' ');
      this.userData.typePlan = namePlanAux.includes('Familiar') ? 'Familiar' : 'Individual';

      const userDataLocal = JSON.stringify(this.userData);
      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      sessionStorage.setItem('userData', encryptedUserDataLocal);

      try {

        await ShieldService.newCreateStep(this.userData, null, this.planDataAux, this.servicesData, 'Planes', tokenStep)

      } catch (error) {
        console.log("Cart Fail");
      }

      if (this.userData.email && this.activeCampaingUse == 'TRUE') {
        const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

        this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;

        await ShieldService.updateContactActiveCampain(null, this.planDataAux, this.servicesData, 1);

        const servicesDataLocal = JSON.stringify(this.servicesData);
        const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
        sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

      }

      if (namePlanAux.includes('Familiar')) {
        this.$router.push({ path: '/og/beneficiarios' })
      } else if (!namePlanAux.includes('Familiar')) {
        this.$router.push({ path: '/og/dps' })
      }
    },
  },
};
</script>

<style scoped>

.ContainerPlans {
  border: 2px solid #D4D4D4;
  border-radius: 12px;
}

.hrLinePlan {
  border: 1px solid #D4D4D4;
  border-radius: 12px;
}

.line-break {
  display: block;
}

.labelElige {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  padding: 2%;
}

.labelPlanes {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
}

.planSubTopes {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #4F74E3;
}

.planSubShield {
  background: #F3F3F3;
  border-radius: 4px;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 8px;
  width: 90%;
}

.planSubShieldDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  text-align: justify;
  color: #2D387C;
  margin: auto;
  width: 83%;
}

.planInidivual {
  width: 100%;
  background: linear-gradient(219deg, #F5F6FF 0%, #DADCFB 50%), #D8D8D8;
  border-radius: 10px 10px 0px 0px;
  transform: matrix(1, 0, 0, 1, 0, 0);
  margin: auto;
  min-width: 300px;
}

.planInidivualDetalle {
  background: linear-gradient(192.38deg, #C4C6FF 3.57%, #F5F6FF 107.06%), #D8D8D8;
  transform: matrix(1, 0, 0, 1, 0, 0);
  width: 327px;
}

.planInidivualName {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #343497;
}

.planIndividualPrecio {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #343497;
}

.planIndividualSubPrecio {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #000000;
}

.planIndividualDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  color: #000000;
}

.planIndividualSubDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #343497;
}

.planIndividualVerMas {
  background: #617BFB;
  border-radius: 0px 0px 10px 10px;
  width: 100%;
  height: 38.91px;
  text-transform: uppercase;
}

.planIndividualProtegete {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: normal;
  text-align: center;
  letter-spacing: 0.02em;
  color: #343497;
  /* background-color: black !important; */
}

.planIndividualCaracteristicas {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 128.02%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #3C3C3C;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planIndividualBeneficios {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #3C3C3C;
  flex: none;
  order: 1;
  flex-grow: 0;
  width: 75%;
  /* text-indent: -15px; */
  text-align: justify;
  margin: auto;
}

.planIndividualBeneficios::before {
  content: '';
  background-image: url('../assets/images/ticket-blue.png');
  /* Ruta a tu imagen de ícono */
  background-size: cover;
  /* Ajustar la imagen para que cubra completamente el área */
  background-repeat: no-repeat;
  /* Evitar que la imagen se repita */
  position: absolute;
  width: 16px !important;
  /* Ancho del ícono */
  height: 16px !important;
  /* Altura del ícono */
  margin-left: -26px;
  margin-top: 9px;
}

.planIndividualVerDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 1px;
  text-decoration-line: underline;
  text-transform: uppercase;
  color: #4040A3;
  text-shadow: 4px 8px 24px rgba(251, 148, 0, 0.25);
}

.elegirPlan {
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 10px;
  height: 39px;
  top: calc(50% - 39px/2 + 100px);
  background: #4F74E3;
  border: 2px solid #4F74E3;
  border-radius: 8px;
}

.elegirPlan2 {
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 10px;
  height: 39px;
  top: calc(50% - 39px/2 + 100px);
  background: #4F74E3;
  border: 2px solid #4F74E3;
  border-radius: 8px;
}

.skin-movil {
  background: #FFFFFF;
  background-position: center;
  background-size: cover;
  border-color: #ECECEC;
  border: 1px solid #ECECEC;
}

.planFamiliar {
  width: 100%;
  background: linear-gradient(294.61deg, #2D387C -41.93%, #4F74E3 40.77%);
  border-radius: 10px 10px 0px 0px;
  transform: matrix(1, 0, 0, 1, 0, 0);
  margin: auto;
}

.planFamiliarRecomendado {
  display: flex;
  /* flex-direction: row;
  justify-content: center; */
  align-items: center;
  /* padding: 5px 25px;
  gap: 8px; */
  width: 136px;
  height: 22px;
  border-radius: 10px 10px 0px 0px;
}

.planFamiliarConveniente {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 12px;
  /* letter-spacing: 0.5px; */
  text-transform: uppercase;
  color: #FFFFFF;
  flex: none;
  order: 0;
  background: linear-gradient(294.61deg, #2D387C -41.93%, #4F74E3 40.77%);
  padding: 8px 25px;
  gap: 8px;
  width: 100%;
  height: 52px;
  border-radius: 12px 12px 0px 0px;
  /* margin-left: 45%; */
  min-width: 300px;
  text-align: center;
  margin: auto;
  place-content: center;
}

.planFamiliarConvenienteValid {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #FFFFFF;
  flex: none;
  order: 0;
  background: linear-gradient(270deg, #4F74E3 -15.95%, #2D387C 40.73%, #4F74E3 115.59%);
  padding: 8px 25px;
  gap: 8px;
  width: 100%;
  height: 28px;
  border-radius: 0px 0px 0px 0px;
  /* margin-left: 45%; */
  min-width: 300px;
  text-align: center;
}

.planShield{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 66px;
  background: #ECF0FC;
  border-radius: 4px;
  width: 90%;
  margin: auto;
}

.imgShield {
  width: 35px;
  height: 35px;
  margin-left: 7px;
}

.imgSand {
  width: 25px;
  height: 25px;
  /* margin: auto; */
}

.planShieldDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  text-align: justify;
  color: #2D387C;
  margin: auto;
  width: 78% !important;
}

.planFamiliarName {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  color: #2D387C;
  margin: auto;
  margin-top: 0%;
}

.planFamiliarPrecio {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 600;
  font-size: 39px;
  line-height: 34px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #4F74E3;
}

.planFamiliarSubPrecio {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  text-align: center;
  color: #2D387C;
  margin-bottom: 0px !important;
}


.planFamiliarDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  color: #FFFFFF;
}

.planFamiliarSubDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #2D387C;
  margin: auto;
  justify-content: center;
  justify-items: center;
  align-items: center;
  display: flex;
  margin-top: 3%;
}

.v-expansion-panel-header {
  background: #ECF0FC !important;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  color: #2D387C;
  border-radius: 10px !important;
  padding: 3px 20px;
  /* // height: 75% !important; */
}

.v-expansion-panels {
  margin: auto;
  width: 93% !important;
}

.v-expansion-panel {
  flex: 9 0 99%;
  max-width: 100%;
  position: initial !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.text-expan {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 13px !important;
  line-height: 25px;
  color: #4D4D4D !important;
}

.planFamiliarVerMas {
  background: #343497;
  border-radius: 0px 0px 10px 10px;
  width: 100%;
  height: 38.91px;
  text-transform: uppercase;
  margin: auto;
}

.planFamiliarProtegete {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #FFFFFF;
}

.planFamiliarCaracteristicas {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 128.02%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planFamiliarBeneficios {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #3C3C3C;
  flex: none;
  order: 1;
  flex-grow: 0;
  width: 191px;
  /* text-indent: -15px; */
  text-align: justify;
  margin: auto;
}

.planFamiliarBeneficios::before {
  content: '';
  background-image: url('../assets/images/ticket-blue.png');
  /* Ruta a tu imagen de ícono */
  background-size: cover;
  /* Ajustar la imagen para que cubra completamente el área */
  background-repeat: no-repeat;
  /* Evitar que la imagen se repita */
  position: absolute;
  width: 16px !important;
  /* Ancho del ícono */
  height: 16px !important;
  /* Altura del ícono */
  margin-left: -23px;
}

.planFamiliarVerDetalle {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 1px;
  text-decoration-line: underline;
  text-transform: uppercase;
  color: #4040A3;
  text-shadow: 4px 8px 24px rgba(251, 148, 0, 0.25);
}

.texto {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: rgba(0, 0, 0, 0.5);
  flex: none;
  order: 1;
  flex-grow: 0;
}

.textoAzul {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400px;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #2D387C;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.encabezado {
  color: #2D387C;
  font-size: 18px;
  font-weight: 600;
}

.superpuesto {
  content: 'Nuevo';
  margin-top: -11% !important;
  width: 45px !important;
  height: 32px;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: bold;
  background: #4F74E3;
  border-radius: 0px 10px 0px 20px;
  margin-left: 255px;
  margin-bottom: -2px;
}

.p-desc {
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 11px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #FFFFFF;
  margin: auto;
}

.superpuestoFam {
  content: 'Nuevo';
  margin-top: -3% !important;
  width: 45px !important;
  height: 32px;
  justify-content: center;
  align-items: center;
  color: #2D387C;
  font-size: 14px;
  font-weight: bold;
  background: #ECECEC;
  border-radius: 0px 0px 0px 20px;
  margin-left: 255px;
  margin-bottom: -2px;
}

.p-descFam {
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 11px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #2D387C;
  margin: auto;
}

#app>div>main>div>div>div.v-stepper.v-sheet.theme--light.elevation-0>div.v-stepper__items>div>div>div:nth-child(11)>div:nth-child(2)>div {
  border-radius: 10px 10px 10px 10px;
}

.v-expansion-panel::before {
  content: none;
}
</style>